module.exports = __webpack_public_path__ + "media/icons/list-babd361b.png";